var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8208 2.88076H7.65894C7.82805 2.88076 7.9653 2.75143 7.9653 2.59207V0.859972C7.9653 0.700619 7.82805 0.571289 7.65894 0.571289H5.8208C3.96304 0.571289 2.45086 1.99565 2.45086 3.74681V5.76759H0.306358C0.137248 5.76759 0 5.89692 0 6.05627V7.78837C0 7.94773 0.137248 8.07706 0.306358 8.07706H2.45086V14.1394C2.45086 14.2988 2.58811 14.4281 2.75722 14.4281H4.59537C4.76448 14.4281 4.90172 14.2988 4.90172 14.1394V8.07706H7.04623C7.17796 8.07706 7.29499 7.99738 7.33727 7.8796L7.94998 6.1475C7.98123 6.05974 7.9653 5.96274 7.90771 5.8871C7.8495 5.81205 7.75759 5.76759 7.65894 5.76759H4.90172V3.74681C4.90172 3.26932 5.31408 2.88076 5.8208 2.88076Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d8c887adb5e494d8f5db316ea2708446.svg";
export { ForwardRef as ReactComponent };